import React from "react";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const GeneralTable = ({
  currentSectionName,
  tableData,
  insulinType,
  tableHeaders,
  handleRemove,
}) => {
  return (
    <>
      <Grid container spacing={3} style={{ marginTop: "10px" }}>
        <TableContainer
          component={Paper}
          className="ml-10px mr-10px mb-20px sputumtable"
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {Object.keys(tableHeaders).map((header) => (
                  <TableCell key={header}>{tableHeaders[header]}</TableCell>
                ))}
                <TableCell>Remove</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={row[insulinType] + index}>
                {Object.keys(tableHeaders).map(header => {
                 return <TableCell>{(row[header] ? row[header] : "N/A")}</TableCell>
                })}
                  <TableCell onClick={() => handleRemove(tableData, row.eventdetails ? row.eventdetails.event : "NA", index)}>
                    <DeleteIcon />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
};

export default GeneralTable;